// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swatches":"MCYxo","active":"wFSvF","additional-swatches":"_2xWR3","loadingContainer":"J0oJu","loading":"_7-k-H","loadingSwatch":"RR0-6","containerLg":"Qpbc6"};